<template>
  <div>
    <div id="dtbDatum1Div" class="jqcalendar input-group ">
      
      <input class="form-control" :disabled="disabled"
      type="time"
    v-focus="focus"     
    v-on:blur="changevalonblur()" 
    ref="input" 
    :value="value">    

      
    </div>

        

  </div>
</template>
<script>

export default {      
  name: 'XVtime',
  props: {
      focus: {
        type: Boolean,        
        default: false
      },
      id: {
        type: String,
        required: true
      },
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
  },
  data: function () {
    return {
        time: null,
        showpicker: false
    }
  },
  methods: {
    picker: function() {      
      this.showpicker = true
    },
    changevalonblur: function() {
      
      this.$emit('input', this.$refs.input.value)  
      this.$emit('formvaluechanged', 
        {
          type: this.$vnode.componentOptions.tag,
          value: this.$refs.input.value,
          id: this.id,
          formdata: this.formdata
        }
      )  
    }
  }
  
}
</script>
